import { routeConstants } from 'app/routes/route-constants';
import * as React from 'react';
import { Route } from 'react-router-dom';

export const generateRouteCodetablePaths = (
  options: {
    component: React.ComponentType<React.PropsWithChildren<unknown>>;
    levels?: number;
    suffix?: string;
    prefix?: string;
  }): React.ReactNode => {
  const prefix = options.prefix ?? '';
  const suffix = options.suffix ?? '';
  const routes = [];
  let codetables = ':codetableId0';

  for (let i = 1; i <= options.levels + 1; i++) {
    const key = i.toString() + options.prefix + options.suffix;
    routes.push(<Route key={key} path={prefix + codetables + suffix} element={<options.component />} />);
    routes.push(<Route key={key + 'section'}
      path={prefix + codetables + suffix + '/' + routeConstants.section} element={<options.component />}
    />);
    codetables += '/:codetableId' + i;
  }

  return routes;
};

export const generateRouteLevels = (
  options: {
    component: React.ComponentType<React.PropsWithChildren<unknown>>;
    suffix?: string;
    prefix?: string;
  }) => {
  const prefix = options.prefix ?? '';
  const suffix = options.suffix ?? '';
  const routes = [];
  let params = '';

  for (let i = 1; i <= 5; i++) {
    const key = i.toString() + options.prefix + options.suffix;
    routes.push(<Route key={key} path={prefix + params + suffix} element={<options.component />} />);
    params += '/:level' + i + '/:level' + i + 'Value';
  }

  return routes;
};
